/**
 * Pure H OS · Phase D Wave 4 · Cost Centers (types + live view).
 * MongoDB collection: `pureh_cost_centers`.
 */
import { liveArray } from "../services/store";

export type CostCenter = {
  id: string;
  code: string;
  name: string;
  owner: string;
  month: string;
  budgetEGP: number;
  spentEGP: number;
  remainingEGP: number;
  utilizationPct: number;
};

export const COST_CENTERS: CostCenter[] = liveArray<CostCenter>("cost_centers");
